// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SectorStayServicesComponent } from './sector-stay-services.component';
import { SectorStayServicesService } from '../../shared/services/sector-stay-services/sector-stay-services.service';
import { ServicesTableModule } from '../../shared/components/services-table/services-table.module';
import { TableServicesServiceModule } from '../../shared/services/table-services/table-services.module';

@NgModule({
    declarations: [
        SectorStayServicesComponent,
    ],
    imports: [
        CommonModule,
        ServicesTableModule,
        TableServicesServiceModule,
    ],
    exports: [
        SectorStayServicesComponent,
    ],
    providers: [
        SectorStayServicesService,
    ],
})
export class SectorStayServicesModule {}